import React from 'react';
import CustomRoute from '@src/Router';
import LawyerApplication from './Application';
import LawyerApplicationStatus from './Status';

import Layout from '@src/components/organisms/RooLayout/Layout';
import { useGetMyLawyerApplicationQuery } from '@src/apollo/hooks';
import Loader from '@atoms/Loader';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

const Directory: React.FC = () => {
  const { t } = useTranslation();
  const { data, loading } = useGetMyLawyerApplicationQuery();
  if (loading) return <Loader />;
  return (
    <Layout theme="blue">
      <Helmet>
        <title>{t('seo.application_title')}</title>
        <meta name="description" content={t('seo.application_description')} />
        <link rel="canonical" href={t('seo.canonical.application')} />
      </Helmet>
      <CustomRoute
        exact
        path="/application"
        Component={
          data?.getMyLawyerApplication
            ? LawyerApplicationStatus
            : LawyerApplication
        }
      />{' '}
    </Layout>
  );
};

export default Directory;
